import { Law } from "../Model/Law";
import { Query } from "../Model/Query";
export class LawService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(lawId) {
        if (lawId) {
            const response = await this.apiService.get('law/' + lawId);
            if (!response.ok) {
                throw new Error(`Error al obtener la ley`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener LawId`);
        }
    }
    async findLaws(opts) {
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`laws?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener las leyes`);
            }
            const content = await response.json();
            return content.map(law => new Law(law).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
}
